import { defineRule } from 'vee-validate'
import { REGEXPS } from '@/base/const/regexp.const'

export function registerRules() {
  defineRule('required', (value) => {
    if (value === 0) return true
    return !!value || 'required'
  })

  defineRule('requiredPayway', (value) => {
    if (value === 0) return true
    return !!value || 'requiredPayway'
  })

  // osobna reguła dla grupy portfeli (Google Pay / Apple Pay) - różni się tylko komunikatem,
  // bo „wybierz bank" nie ma sensu przy portfelach
  defineRule('requiredWallet', (value) => {
    if (value === 0) return true
    return !!value || 'requiredWallet'
  })

  defineRule('requiredCreditCard', (value) => {
    if (value === 0) return true
    return !!value || 'requiredCreditCard'
  })

  defineRule('requiredVisaMobile', (value) => {
    if (value === 0) return true
    return !!value || 'requiredVisaMobile'
  })

  defineRule('requiredTerms', (value) => {
    if (value === 0) return true
    return !!value || 'requiredTerms'
  })

  defineRule('requiredConsent', (value) => {
    if (value === 0) return true
    return !!value || 'requiredConsent'
  })

  defineRule('email', (value) => {
    if (!value) return true
    if (typeof value !== 'string') return 'email'
    return REGEXPS.emailValidator.test(value) || 'email'
  })

  defineRule('blikCode', (value) => {
    if (!value) return true
    if (typeof value !== 'string') return 'blikCode'
    return REGEXPS.blikValidator.test(value) || 'blikCode'
  })

  defineRule('pattern', (value, [pattern]) => {
    if (!value || !pattern || !pattern.length) return true
    return new RegExp(pattern).test(value) || 'pattern'
  })

  defineRule('maxlength', (value, [max]) => {
    if (!value) return true
    const limit = Number(max)
    if (!Number.isFinite(limit)) return true
    return String(value).length <= limit || 'maxlength'
  })
}
